import { render, staticRenderFns } from "./LoginWithMicrosoft.vue?vue&type=template&id=44f6c80a&scoped=true"
import script from "./LoginWithMicrosoft.vue?vue&type=script&lang=js"
export * from "./LoginWithMicrosoft.vue?vue&type=script&lang=js"
import style0 from "./LoginWithMicrosoft.vue?vue&type=style&index=0&id=44f6c80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6c80a",
  null
  
)

export default component.exports